import React, { useEffect, useState, useCallback } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import {
  Container,
  Content,
  Title,
  Field,
  Input,
  Label,
  IsMba,
} from "./styles";
import { getUserNode } from "../../../../services/auth_node";
import { producaov2 as api } from "../../../../services/apis";
import { withRouter } from "react-router-dom";
import { getUSER } from "../../../../services/auth";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";
import swal from "sweetalert";
import AlunosSelector from "../../../../components/Admin/AlunosSelector";
import CursosSelector from "../../../../components/Admin/CursosSelector";

const COURSE_TYPES = {
  COURSE: "course",
  FORMATION: "formation",
  MBA: "mba",
};

const ControleEnvios = (props) => {
  const user = getUSER(); //obter usuário atual
  const [aluno, setAluno] = useState("");
  const [curso, setCurso] = useState([]);
  const [tempoAcesso, setTempoAcesso] = useState("");
  const [dataLimite, setDataLimite] = useState("");
  const [enviarEmail, setEnviarEmail] = useState(false);
  const [observacao, setObservacao] = useState("");
  const [novoUsuario, setNovoUsuario] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAlunoChange = useCallback((value) => {
    setAluno(value);
  }, []);

  const handleCursoChange = useCallback((value) => {
    setCurso(value);
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      if (!curso || curso.length === 0) {
        swal("Erro", "Por favor, selecione pelo menos um curso.", "error");
        return;
      }

      const cursosParaEnviar = curso.map((c) => {
        const cursoId = typeof c === "object" ? (c.value || c.id) : c;
        return {
          id: cursoId,
          type: c.type || COURSE_TYPES.COURSE,
        };
      });

      const payload = {
        id_pessoa: aluno,
        id_courses: cursosParaEnviar,
        validade: tempoAcesso,
        enviarEmail,
        observacao,
        novoUsuario,
      };

      if (
        !payload.id_pessoa ||
        !payload.id_courses.length ||
        !payload.observacao
      ) {
        swal(
          "Erro",
          "Preencha Aluno, pelo menos um Curso e Observação.",
          "error",
        );
        return;
      }

      setLoading(true);

      api
        .post("admin/atribuir/curso", payload)
        .then((res) => {
          let logs = {
            local: "AlunosAtribuir",
            texto: `atribuiu ${curso.length} curso(s)/MBA(s) para o aluno (${aluno})`,
          };

          api.post("system_logs", {
            acao: JSON.stringify(logs),
          });

          swal("Requisição bem sucedida", res.data, "success");

          setNovoUsuario(false);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          const msg = err.response?.data?.message;
          swal(
            "Requisição mal sucedida",
            msg || "Não foi possível efetuar a atribuição de curso ao aluno",
            "error",
          );

          setLoading(false);
        });
    },
    [aluno, curso, tempoAcesso, enviarEmail, observacao, novoUsuario],
  );

  const handleTempoAcessoChange = useCallback((e) => {
    const newTempoAcesso = e.target.value;

    const today = new Date();
    const newDate = new Date(
      today.valueOf() + newTempoAcesso * 24 * 60 * 60 * 1000,
    );
    const newDataLimite = newDate.toISOString().split("T")[0];

    setTempoAcesso(newTempoAcesso);
    setDataLimite(newDataLimite);
  }, []);

  const handleDataLimiteChange = useCallback((e) => {
    const newDataLimite = e.target.value;

    const today = new Date();
    const newDate = new Date(newDataLimite);
    const dateDifference = newDate.valueOf() - today.valueOf();
    const newTempoAcesso = Math.ceil(dateDifference / (24 * 60 * 60 * 1000));

    setDataLimite(newDataLimite);
    setTempoAcesso(newTempoAcesso);
  }, []);

  return (
    <Container>
      <AdminMenu />

      <Content>
        <Title>Atribuir Curso à Aluno</Title>
        <Form onSubmit={handleSubmit}>
          <Tab
            panes={[
              {
                menuItem: { content: "Informações", icon: "info" },
                render: () => (
                  <>
                    <AlunosSelector
                      handleChange={handleAlunoChange}
                      cadastro
                      cadastrou={setNovoUsuario}
                    />

                    <CursosSelector fullInfo handleChange={handleCursoChange} is_multiple={true} />

                    <Field>
                      <Label>Observação:</Label>
                      <TextArea
                        value={observacao}
                        onChange={(e) => setObservacao(e.target.value)}
                      />
                    </Field>

                    <Form.Group>
                      <Field>
                        <Label>
                          Tempo de Acesso - Por dias (180 = Indeterminado)
                        </Label>
                        <Input
                          value={tempoAcesso}
                          onChange={handleTempoAcessoChange}
                          type={"number"}
                        />
                      </Field>

                      <Field>
                        <Label>Tempo de Acesso - Por data final</Label>
                        <Input
                          value={dataLimite}
                          onChange={handleDataLimiteChange}
                          type={"date"}
                        />
                      </Field>
                    </Form.Group>

                    <Field>
                      <Checkbox
                        label="Enviar email junto com a atualização?"
                        checked={enviarEmail}
                        onChange={(e) => setEnviarEmail(!enviarEmail)}
                      />
                    </Field>
                  </>
                ),
              },
            ]}
          />
          <Button color={"black"} loading={loading}>
            <Icon name="user plus" /> Atribuir
          </Button>
        </Form>
      </Content>
    </Container>
  );
};

export default withRouter(ControleEnvios);